import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({
  selector: 'customer-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card{
      height: 50px;
    }        
  `],
  template: `
    <!--{{customer | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="defaultImage" shape="circle" style="background-size: contain; padding: 6px; background-color: #2ecc71"></kendo-avatar>
      <div class="card-details">
        <div class="card-subtitle no-wrap">
          {{ customer.rfc }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ customer.name }} 
        </div>
        <div class="card-subtitle no-wrap">
          Crédito: {{ customer.credit_days }} días
        </div>
      </div>
      <div class="card-actions" *ngIf="authService.hasPermission(['CLIENTES:EDITAR','CLIENTES:ELIMINAR'])">
        <span class="k-icon k-icon-md k-i-arrow-chevron-right k-color-secondary" style="color: #2ecc71!important"></span>
      </div>
    </div>
  `,    
})
export class CustomerCardComponent extends BaseCardComponent {

  @Input() customer!: any;

  @Input() defaultImage: string = environment.assets.DEFAULT_CUSTOMER;

  @Input() returnUrl: string;


  constructor(public intl: IntlService, public router: Router, public authService: AuthService) { 

    super(intl, router)

  }

  public selectItem(event: any) {

    if(this.authService.hasPermission(['CLIENTES:EDITAR','CLIENTES:ELIMINAR']))
      this.router.navigate(['/customer_edit/' + this.customer.id], {state: {returnUrl: this.returnUrl}});

  }

}